import React from 'react'

export default function Evaluation_temp() {
  return (
    <div className="participate-section"> 
      <h2 className="h3-medium section-title title-navy-blue pb-2 about-readmore-title">Round 1</h2>
          {/* <div>evaluation_temp</div> */}
          {/* <h2>A clean timeline design | <a href="https://codepen.io/hunzaboy/pen/qBWRBXw" target="_blank">Checkout Version 2</a></h2> */}

      <div class="time_line">
        {/* Round 1 || Stage 1 || Type 1 */}
        <div class="time_line__event  animated fadeInUp delay-3s time_line__event--type1">
          <div class="time_line__event__icon ">
            <i class="lni-cake"></i>
            <div class="time_line__event__date">
              Stage 1
            </div>
          </div>
          <div class="time_line__event__content ">
            <div class="time_line__event__title">
              Submission 
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">Registered Teams will develop their TTS models, focusing on accent and style transfer capabilities using SYSPIN dataset and English + Gujarati TTS corpora, and submit Huggingface repository with the server code, any custom datasets used, active REST API Url for a server hosting the Model (API Specifications provided below), Technical write up in PDF format. The submission window remains open from 22 Nov to 3 Dec.</p>
            </div>
          </div>
        </div>
        {/* Round 1 || Stage 2 || Type 2 */}
        <div class="time_line__event animated fadeInUp delay-2s time_line__event--type1">
          <div class="time_line__event__icon">
            <i class="lni-burger"></i>
            <div class="time_line__event__date">
              Stage 2
            </div>
          </div>
          <div class="time_line__event__content">
            <div class="time_line__event__title">
              Short listing based on Objective Metrics 
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">We will evaluate the submitted systems by running our standardized test sets, retrieving model outputs through the provided API endpoints, and then computing key performance metrics including Word Error Rate (WER), Character Error Rate (CER), model size, inference time, and FLOPs to generate 100 characters.
            </p>
            </div>
          </div>
        </div>
        {/* Round 1 || Stage 3 || Type 3 */}
        <div class="time_line__event animated fadeInUp delay-1s time_line__event--type1">
          <div class="time_line__event__icon">
            <i class="lni-slim"></i>
            <div class="time_line__event__date">
              Stage 3
            </div>
          </div>
          <div class="time_line__event__content">
            <div class="time_line__event__title">
              Short Listing based on Subjective Metrics
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">From the shortlisted submissions, we will proceed to manual evaluation, where human evaluators will listen to the model’s inference audio and assess the Mean Opinion Score (MOS) for naturalness and speaker similarity. Evaluation timeline ends on 15 Dec</p>
            </div>

          </div>
        </div>
        {/* Round 1 || Stage 4 || Type 1 */}
        <div class="time_line__event animated fadeInUp time_line__event--type1">
          <div class="time_line__event__icon">
            <i class="lni-cake"></i>
            <div class="time_line__event__date">
              Stage 4
            </div>
          </div>
          <div class="time_line__event__content">
            <div class="time_line__event__title">
              10 Shortlisted teams Proceed to Round 2
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">Out of all submissions, 10 teams will be selected to advance to Round 2, where participants will have time to improve their models before resubmitting them. 10 shortlisted teams will be announced during 15 Dec-20 Dec
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2 className="h3-medium section-title title-navy-blue pb-2 about-readmore-title">Round 2</h2>
      <div class="time_line">
        <div class="time_line__event  animated fadeInUp delay-3s time_line__event--type1">
          <div class="time_line__event__icon ">
            <i class="lni-cake"></i>
            <div class="time_line__event__date">
              Stage 1 
            </div>
          </div>
          <div class="time_line__event__content ">
            <div class="time_line__event__title">
              Submission R2 at Venue
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">Participants need to submit their (revised) models and technical write-up. The submitted model will go through new set of test files. The in-person final event to be hosted at IISc Bangalore during the final round of the hackathon. Round 2 will be held in-person in 28 Jan 2026.</p>
            </div>
          </div>
        </div>

        <div class="time_line__event  animated fadeInUp delay-3s time_line__event--type1">
          <div class="time_line__event__icon ">
            <i class="lni-cake"></i>
            <div class="time_line__event__date">
              Stage 2
            </div>
          </div>
          <div class="time_line__event__content ">
            <div class="time_line__event__title">
              Objectice Metric Evaluation 
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">The models will once again be evaluated using objective metrics, including WER, CER, model size, inference time, and FLOPs to generate 100 characters, to ensure consistent and fair comparison across all submissions.
              </p>
            </div>
          </div>
        </div>

        <div class="time_line__event  animated fadeInUp delay-3s time_line__event--type1">
          <div class="time_line__event__icon ">
            <i class="lni-cake"></i>
            <div class="time_line__event__date">
              Stage 3
            </div>
          </div>
          <div class="time_line__event__content ">
            <div class="time_line__event__title">
              Subjective Analysis by Human-experts and Q&A
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">Final demos by the shortlisted teams will be evaluated by a jury of language and AI experts, followed by a Q&A session with the team members to discuss their submission. </p>
            </div>
          </div>
        </div>

        <div class="time_line__event  animated fadeInUp delay-3s time_line__event--type1">
          <div class="time_line__event__icon ">
            <i class="lni-cake"></i>
            <div class="time_line__event__date">
              Final Stage
            </div>
          </div>
          <div class="time_line__event__content ">
            <div class="time_line__event__title">
              Announcment of Winners
            </div>
            <div class="time_line__event__description">
              <p className="jostRegular h6-small section-title about-box-text">Based on the performance of the teams and their TTS models, the winners will be announced and prizes will be awarded. The post-event wrap-up to include: Public declaration of results, Sharing of selected submissions (as per licensing), and Final report by the agency covering outreach, engagement, and impact
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
